import { render, staticRenderFns } from "./roomFixed.vue?vue&type=template&id=7aaa6ea2"
import script from "./roomFixed.vue?vue&type=script&lang=js"
export * from "./roomFixed.vue?vue&type=script&lang=js"
import style0 from "./roomFixed.vue?vue&type=style&index=0&id=7aaa6ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports